"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var Avatar_1 = __importDefault(require("./Avatar"));
var styles = {
    email: function (theme) { return react_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 150%;\n    color: ", ";\n  "], ["\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 150%;\n    color: ", ";\n  "])), theme.color.GRAY.DEFAULT); },
    name: function (theme) { return react_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 150%;\n    color: ", ";\n  "], ["\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 150%;\n    color: ", ";\n  "])), theme.color.GRAY.DARK_2); },
};
var AvatarListItem = function (props) {
    var theme = style_1.useTheme();
    var email = props.email, name = props.name, size = props.size, rest = __rest(props, ["email", "name", "size"]);
    var itemSize = size === 'xs' ? size : 'sm';
    return (react_1.jsx("div", { css: {
            padding: '10px 16px',
            display: 'flex',
            gap: 12,
            alignItems: 'center',
        } },
        react_1.jsx("div", { css: {
                alignSelf: 'center',
            } },
            react_1.jsx(Avatar_1.default, __assign({ name: "", size: itemSize }, rest))),
        react_1.jsx("div", null,
            react_1.jsx("div", { css: styles.name(theme) }, name),
            react_1.jsx("div", { css: styles.email(theme) }, email))));
};
exports.default = AvatarListItem;
var templateObject_1, templateObject_2;
